<template>
  <div class="new-pro-bg">
    <ucar-title type="confirmBack">{{title}}</ucar-title>
    <!-- 待入驻显示模块 -->

    <div class="progress-success" v-if="((enlistInfo.enlistStatus===3 || enlistInfo.enlistStatus===4|| enlistInfo.enlistStatus===5)&&gaeaValue==='0')">
      <div class="success-pic">
        <div class="success-pic-text">
          <p class="success-pic-info">恭喜你！</p>
          <p class="success-pic-info-next">{{enlistInfo.mobile}}的司机</p>
        </div>
      </div>
      <div class="success-info">
        <p class="info-text">欢迎成为神州大家庭中的一员，3日内相关人员会主动联系您，敬请期待！</p>
      </div>
    </div>

    <!-- 已入驻显示模块 -->
    <div class="progress-success" v-if="((enlistInfo.enlistStatus===3 || enlistInfo.enlistStatus===4|| enlistInfo.enlistStatus===5)&& gaeaValue==='1') ">
      <div class="success-pic">
        <div class="success-pic-text">
          <p class="success-pic-info">恭喜你！</p>
          <p class="success-pic-info-next">{{enlistInfo.mobile}}的司机</p>
        </div>
      </div>
      <div class="success-info">
        <p class="info-text">欢迎成为神州大家庭的一员，下载司机端APP，使用报名手机号登录，密码为本人身份证号最后6位登录司机端完成待办事项上线接单吧！</p>
      </div>
      <div class="footer">
        <button type="button" class="btn-submit btn-submit-enable" @click="goDownload">下载神州司机端APP 开始工作</button>
      </div>
    </div>

    <!-- 完善信息显示模块 -->

    <div class="progress-continued" v-if="enlistInfo.enlistStatus===1 || enlistInfo.enlistStatus===2">
      <div class="continued-success-pic"></div>
      <div class="continued-success-pic-text">
        <p class="info-text">欢迎你的加入</p>
        <p class="info-text">完善信息即可成为神州司机</p>
        <p class="info-text2" v-if="enlistInfo.companyName!==''">{{enlistInfo.companyName}}</p>
      </div>
      <div class="footer">
        <button type="button" class="btn-submit btn-submit-enable" @click="goUpload">继续上传资料</button>
      </div>
    </div>

    <!-- 申请单失效显示模块 -->

    <div class="progress-fail" v-if="enlistInfo.status===1">
      <div class="progress-fail-pic"></div>
      <div class="continued-success-pic-text">
        <p class="info-text3">对不起</p>
        <p class="info-text3">您的申请单已失效</p>
      </div>
      <div class="footer">
        <button type="button" class="btn-submit btn-submit-enable" @click="goToIndex">重新申请</button>
      </div>
    </div>

    <!-- 审核拒绝显示模块 -->

    <div class="progress-reject" v-if="enlistInfo.enlistStatus===6">
      <div class="progress-reject-pic"></div>
      <div class="continued-success-pic-text">
        <p>非常遗憾</p>
        <p>您的审核已被系统拒绝</p>
      </div>
      <div class="fail-reason-wrapper">
        <div class="wrapper-flex">
          <div class="fail-title">拒绝原因</div>
          <div class="fail-time">{{enlistInfo.artificialReviewTime}}</div>
        </div>
        <div class="fail-reason" v-if="!vuexCrimeRejectReason">{{driverArtificialReason.length!==0?driverArtificialReason[0]:vehicleArtificialReason[0]}}</div>
        <div class="fail-reason" v-if="vuexCrimeRejectReason">{{vuexCrimeRejectReason}}</div>
      </div>
      <div class="footer">
        <button type="button" class="btn-submit btn-submit-enable" @click="goToIndex">重新申请</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewRecruitProgress, gaeaQuery } from '../../api'
import { hideKey } from '../../utils/transform'
export default {
  components: {
  },
  data () {
    return {
      enlistInfo:{},
      driverArtificialReason:[],
      vehicleArtificialReason:[],
      gaeaValue: '0',
    }
  },
  methods: {
    goToIndex(){
      this.$router.push('/')
    },

    goUpload(){
      this.changeStatusToFillInfo()
      this.$router.push('/new-driver-info?redirectTo=new-progress-info')
    },

    goDownload(){
      location.assign('https://m.10101111.com/ptdapp/d')
    },

    async getNewRecruitProgressFunc(){
      const res = await getNewRecruitProgress({enlistId: this.vuexRecruitId})
      console.log('getNewRecruitProgressFunc')
      if (res.driverInfo) {
        res.driverInfo.idCardImgbackUrl = res.driverInfo.idCardImgBackUrl
        delete res.driverInfo.idCardImgBackUrl
      }
      res.enlistInfo.mobile = hideKey(res.enlistInfo.mobile)
      this.enlistInfo = res.enlistInfo
      this.driverArtificialReason = res.driverArtificialReason
      this.vehicleArtificialReason = res.vehicleArtificialReason
      // console.log('进度res?',res)
      this.getGaeaRes()
      
    },

    async getGaeaRes(){
      const res = await gaeaQuery({key: 'enlistProgressPage'})
      console.log('getGaeaRes',res)
      console.log((this.enlistInfo.enlistStatus===3 || this.enlistInfo.enlistStatus===4|| this.enlistInfo.enlistStatus===5)&&this.gaeaValue==='1')
      this.gaeaValue = res.value
    },

    routeStore() {
      ucarStorage.setStorage('routeTo','new-progress-info')
    },
  },
  mounted () {
    if (this.$route.query.id) this.setVuexRecruitId(this.$route.query.id)
    // console.log('this.vuexCrimeRejectReason???',this.vuexCrimeRejectReason)
    
    this.getNewRecruitProgressFunc()
    console.log('???',this.gaeaValue)
  },
  created() {
    window.addEventListener('beforeunload', this.routeStore)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.routeStore)
  },
}
</script>

<style lang="stylus" scoped>
  .wrapper-flex{
    display:flex;
    flex-direction:row;

  }
  .fail-title{
    width:50%;
    color:#333;
  }

  .fail-time{
    width:50%;
    text-align:right;
  }

  .fail-reason{
    color:#333;
    margin-top:25px;
  }

  .fail-reason-wrapper{
    padding:32px;
    width:626px;
    height:553px;
    background-color:#E6E6E6;
    border: 1px solid #E6E6E6;
    border-radius: 6px;
    margin:0 auto;
    margin-top:114px;
  }

  .new-pro-bg {
    background-color: #fff !important;
  }

  .progress-success{
    width:100%;
  }

  .progress-reject{
    width:100%;
  }

  .success-pic{
    width:100%;
    height:750px;
    margin :0 auto;
    background :url('../../assets/congratulations.png') no-repeat 100%/100%;
  }

  .continued-success-pic{
    width:90px;
    height:90px;
    margin :0 auto;
    margin-top: 281px;
    background :url('../../assets/progressSuccessCont.png') no-repeat 100%/100%;
  }

  .progress-fail-pic{
    width:90px;
    height:90px;
    margin :0 auto;
    margin-top: 281px;
    background :url('../../assets/progressFail.png') no-repeat 100%/100%;
  }

  .progress-reject-pic{
    width:90px;
    height:90px;
    margin :0 auto;
    margin-top: 120px;
    background :url('../../assets/progressFail.png') no-repeat 100%/100%;
  }

  .success-pic-text{
    padding-top:300px;
    width:300px;
    height:300px;
    margin: 0 auto;
  }

  .continued-success-pic-text{
    width:440px;
    height:100px;
    margin:0 auto;
    margin-top: 45px;
    text-align:center;
    font-size:36px;
    line-height: 60px;
  }

  .success-pic-info-next{
    color: #845832;
    font-size: 32px;
  }

  .success-pic-info{
    color: #845832;
    font-size: 45px;
    font-weight:700;
  }

  .success-info{
    width:560px;
    height :300px;
    margin: 0 auto;
    font-size:30px;
  }

  .info-text {
    color:#D0964B;
  }

  .info-text2 {
    font-size:30px;
  }

  .progress-continued{
    width:100%;
  }

  .progress-fail{
    width:100%;
  }
  
  .footer{
    width:690px;
    height :88px;
    position :fixed;
    bottom:31px;
    left:30px;
  }
</style>